import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, PageHero } from '../components/bits';
import StoriesCarousel from '../components/Stories';
import { ARTICLES } from '../content/articles';
import { API } from '../content/data';

const CATEGORIES = ['All', 'DITEC Stories', 'Student & Alumni', 'Enterprise', 'Research & Intelligence', 'Digital Economy', 'Perspectives'];

export default function Press() {
  const [cat, setCat] = useState('All');
  const [remote, setRemote] = useState(null);
  useEffect(() => {
    axios.get(`${API}/articles`).then((r) => setRemote(r.data)).catch(() => setRemote([]));
  }, []);
  const SOURCE = remote && remote.length ? remote : ARTICLES;
  const list = cat === 'All' ? SOURCE : SOURCE.filter((a) => a.category === cat);
  return (
    <div data-testid="press-page">
    <SEO title="Press & Insights" description="Ideas, stories and evidence from the digital economy." />
      <PageHero
        dark
        ck="press"
        tag="Press & Insights"
        lines={<>Ideas, Stories & Evidence From the <span className="font-serif italic font-normal text-gold">Digital Economy.</span></>}
        intro="Explore perspectives on technology, digital talent, enterprise transformation, AI, cybersecurity, creators, entrepreneurship and the evolving digital economy."
      />

      {/* Alumni Stories */}
      <section className="border-b border-navy/10 bg-white py-16 sm:py-20">
        <div className="wrap">
          <SectionTag>Alumni Journeys</SectionTag>
          <Reveal delay={0.05}>
            <h2 className="text-h2 mt-4 font-semibold">Proof, in <span className="font-serif italic font-normal text-electric">people.</span></h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <StoriesCarousel />
          </Reveal>
        </div>
      </section>

      <section className="bg-paper py-16 sm:py-24">
        <div className="wrap">
          <div className="flex flex-wrap gap-2" data-testid="press-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`press-filter-${c.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                onClick={() => setCat(c)}
                className={`touch-target rounded-full border px-5 py-2.5 text-xs font-semibold tracking-tight transition-colors duration-300 ${
                  cat === c ? 'border-navy bg-navy text-gold' : 'border-navy/15 bg-white text-navy/70 hover:border-electric hover:text-electric'
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {list.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 0.06}>
                <Link
                  to={`/press/${a.slug}`}
                  data-testid={`press-article-${a.slug}`}
                  className={`group flex h-full flex-col rounded-3xl border p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 ${
                    i === 0 && cat === 'All' ? 'border-navy bg-navy text-white hover:shadow-2xl hover:shadow-navy/40 md:col-span-2 lg:col-span-1' : 'border-navy/10 bg-white hover:shadow-xl hover:shadow-navy/10'
                  }`}
                >
                  <span className={`overline !text-[10px] ${i === 0 && cat === 'All' ? 'text-gold' : 'text-electric'}`}>{a.category}</span>
                  <h2 className="mt-4 text-lg font-semibold leading-snug tracking-tight group-hover:opacity-90">{a.title}</h2>
                  <p className={`mt-3 text-sm leading-relaxed ${i === 0 && cat === 'All' ? 'text-white/65' : 'text-navy/65'}`}>{a.summary}</p>
                  <span className={`mt-auto pt-6 font-mono text-xs ${i === 0 && cat === 'All' ? 'text-white/45' : 'text-navy/45'}`}>{a.date} · {a.readTime}</span>
                </Link>
              </Reveal>
            ))}
          </div>
          {list.length === 0 && <p className="mt-12 text-sm text-navy/60">No stories in this category yet — check back soon.</p>}
        </div>
      </section>
    </div>
  );
}
